import styles from './bulk-update-contracts-comp.module.scss';

export default function NoRowsOverlay() {
  return (
    <div className={styles['no-rows-overlay']}>
      <div>
        Upload a CSV or Excel file to see contract data here.
      </div>
    </div>
  );
}
